import { CartItemFragment, CartSubItemFragment } from 'types/api/tickets.types';

export const isCartItemOutOfStock = (
  item: CartItemFragment | CartSubItemFragment,
) =>
  'state' in item &&
  (item.state === 'OutOfStock' || item.state === 'Unavailable');
